require(`angular`);
//require(`angular/angular.min.js.map`);
require(`angular-i18n/angular-locale_pt-br`);
require(`angular-sanitize`);
require(`angular-ui-router`);
//require(`angular-ui-router/release/angular-ui-router.min.js.map`);
require(`angular-ui-validate`);
require(`angular-ui-mask`);

window.ApexCharts = require(`apexcharts`);
window.easepick = require(`../../../node_modules/@easepick/bundle/dist/index.umd.js`);